import React from "react";

export default function KpiTrend({ points = [], width = 120, height = 40, color = "#10b2aa" }) {
  if (!points.length) {
    return <div style={{ fontSize: "12px", color: "#777" }}>No data</div>;
  }
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;

  const coords = points.map((p, i) => {
    const x = (i / Math.max(points.length - 1, 1)) * (width - 10) + 5;
    const y = height - ((p - min) / range) * (height - 10) - 5;
    return `${x},${y}`;
  });
  const path = `M ${coords.join(" L ")}`;

  return (
    <svg width={width} height={height} role="img" aria-label="kpi-trend">
      <path d={path} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {coords.map((coord, idx) => {
        const [x, y] = coord.split(",").map(Number);
        return <circle key={idx} cx={x} cy={y} r={2.5} fill={color} />;
      })}
    </svg>
  );
}
